// extracted by mini-css-extract-plugin
export default {"header":"CardsHeader_header__VZRWk","cover":"CardsHeader_cover__QQ7Vm","h2":"CardsHeader_h2__J+YPl","modal":"CardsHeader_modal__c3ARW","button":"CardsHeader_button__DHFsr"};